import { AnimatePresence, motion, Variants } from "framer-motion";
import { AnimatedCheckMark } from './AnimatedCheckMark';

interface AnimatedListItemProps {
    text: string;
    delay?: number;
}

export const AnimatedListItem = ({ text, delay = 0 }: AnimatedListItemProps) => {
    const containerVariants: Variants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5,
                delay: delay,
                ease: "easeOut"
            }
        }
    };

    const circleVariants: Variants = {
        hidden: {
            scale: 0
        },
        visible: {
            scale: 1,
            transition: {
                duration: 0.3,
                delay: delay + 0.3,
                ease: "easeOut",
                type: "spring",
                stiffness: 200,
                damping: 15
            }
        }
    };

    return (
        <AnimatePresence>
            <motion.div
                className="flex justify-between items-center gap-2 w-full pr-4 pl-6 py-4 bg-osGrey-5 rounded-[18px]"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <span className="text-osBlack text-sm font-semibold">{text}</span>
                <motion.span
                    className="w-5 h-5 bg-osBlack text-white rounded-full flex items-center justify-center"
                    variants={circleVariants}
                    initial="hidden"
                    animate="visible"
                >
                    <AnimatedCheckMark delay={delay + 0.6} size={28} />
                </motion.span>
            </motion.div>
        </AnimatePresence>
    );
};

